import { trpc } from '../../lib/trpc';
import type { Event } from '@wineryxplorer/shared';
import { ContentContainer } from '../ContentContainer';
import { EventCard } from '../EventCard';

interface UpcomingEventsProps {
  venueId: string;
}

export const UpcomingEvents = ({ venueId }: UpcomingEventsProps) => {
  // Show only upcoming events starting from today
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  
  const { data, isPending, error } = trpc.event.listByVenue.useQuery(
    { venueId, startDateFrom: startOfToday.toISOString(), limit: 10 },
    { enabled: Boolean(venueId) }
  );

  if (isPending) {
    return (
      <ContentContainer>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Upcoming Events</h2>
        <p className="text-gray-600">Loading events...</p>
      </ContentContainer>
    );
  }

  if (error) {
    return (
      <ContentContainer>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Upcoming Events</h2>
        <p className="text-red-600">Error loading events: {error.message}</p>
      </ContentContainer>
    );
  }

  // Cast the events array to proper type since tRPC returns unknown
  const events = data.items as Event[];

  return (
    <ContentContainer>
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Upcoming Events</h2>
      {events.length === 0 ? (
        <p className="text-gray-500">No upcoming events scheduled at this time.</p>
      ) : (
        <div className="space-y-4">
          {events.map((event) => (
            <EventCard key={event.id} event={event} />
          ))}
        </div>
      )}
    </ContentContainer>
  );
};
